import React, {ReactElement, useCallback, useState} from 'react';

import {NeighbourIcon} from '../../../resources/Icons';
import Col from '../../common/Col';
import BalloonBox from './BalloonBox';
import NormalButton from './buttons/NormalButton';
import {NeighbourButton} from './buttons/PillButtons';
import ModalButton from './ModalButton';

type HelpNeighbourProps = {
  text: string;
};

const HelpNeighbour = ({text}: HelpNeighbourProps): ReactElement => {
  const [forceReset, setForceReset] = useState(0);

  const onAnswerClick = useCallback(() => {
    setForceReset(prevState => prevState + 1);
  }, []);

  const bottomButton = (
    <div className="flex justify-center">
      <NormalButton className="px-60 mobile:px-10 py-10" onClick={onAnswerClick}>
        Select an Answer
      </NormalButton>
    </div>
  );

  return (
    <ModalButton
      title="Talk to a neighbour"
      button={<NeighbourButton className="mobile:!p-2" />}
      bottom={bottomButton}
      forceReset={forceReset}
    >
      <Col className="mt-8 items-center text-center">
        <div className="w-52 h-52 mb-20">
          <NeighbourIcon />
        </div>
        <BalloonBox>{text}</BalloonBox>
      </Col>
    </ModalButton>
  );
};

export default HelpNeighbour;
